import Passenger from '@/components/Passenger/models/Passenger';
import { PermissionEnum } from '@/models/DestinationRole';
import { User } from '@/models/User';

export interface IStoreRoots {
  state: any;
  getters: any;
}

export function hasPassengerPermission(passengerId: number, permissionLevel: PermissionEnum, storeRoots: IStoreRoots): boolean {
  const user = storeRoots.state.user.me as User;
  const passenger: Passenger = storeRoots.getters['passenger/findPassengerById'](passengerId);
  if (!passenger) {
    return false;
  }
  const destinationIds = passenger.passengerDestinations.map(pd => pd.destinationId);
  const userDestination = user.destinationRoles.find(dr => destinationIds.includes(dr.destinationId));
  
  return userDestination && userDestination.rideitPermission >= permissionLevel;
}